import './body.css';
import 'antd/dist/antd.css';
import React, {useEffect, useState, useRef, useContext} from 'react';
import '@ant-design/compatible';
import { Layout } from 'antd';
import cubejs from '@cubejs-client/core';
import { CubeProvider } from '@cubejs-client/react';
import Header from './components/Header';
import {logOut} from './components/Header';
import SideBar from "./components/SiderBar";
import WebSocketTransport from '@cubejs-client/ws-transport';
import {SideContext} from "./contexts/SideContext";
import {CubeContext} from "./contexts/CubeContext";
import {RoleContext} from "./contexts/RoleContext";
import {LoginContext} from "./contexts/LoginContext";
import {DeleteContext} from "./contexts/DeleteContext";
import ImbaChat from "./pages/OnlineSupport/ImbaChat";
import CheckRole from "./helpers/CheckRole";
import axios from 'axios'
import {
    useLocation,
} from 'react-router-dom';

const API_URL = 'https://stats.imbachat.com';


const imba_id = window.location.hash.split('/')[1];

const user_id = localStorage.getItem('comet-user-id');
const user_token = localStorage.getItem('comet-token');


const AppLayout = ({ children }) => {
    const location = useLocation();
    //console.log('location',location)
    return(
    <Layout
        style={{
            height: '100%',
        }}
    >
        <Header />
        <Layout>
            {(location.pathname.includes("/signIn")) ? ( null ):(<SideBar imba_id={imba_id}/>)}
            <Layout.Content className={'imba_content'}>
                <div>
                    {children}
                </div>
            </Layout.Content>
            <ImbaChat user_id={user_id} user_token={user_token} imba_id={imba_id}/>
        </Layout>
    </Layout>
);
}


const App = ({ children }) => {
    
    const [token, setToken] = useState(localStorage.getItem('cube-token'));
    const [role, setRoleNew] = useState('operator');
    const [login, setLoginNew] = useState(localStorage.getItem('imbachat_login'));
    const [deleted, setDeleteNew] = useState(0);
    const [cube, setCube] = useState([])
    const [sbKey, setSbKey] = useState(0);
    const [token_new, setTokenNew] = useState(0);
    const [token_new_init, setTokenNewInit] = useState(0);
    /*if(localStorage.getItem('comet-token')){ 
        axios.post(
            `https://api.imbachat.com/imbachat/v1/widget/user_by_token/${imba_id}`,
            {
                token: localStorage.getItem('comet-token')
            },
            {
                headers: {
                    //"Access-Control-Allow-Origin": "*",
                }
            }
        ).then((response) => {
           // console.log(response)
            let data = response.data
                
            setRoleNew(data.role);
        }).catch((error) => {
            
    
        })
    }
    if(!localStorage.getItem('get-token-cube')){ 
        axios.post(
            `https://api.imbachat.com/imbachat/v1/${imba_id}/getTokenCube`,
            {
                token: localStorage.getItem('comet-token')
            },
            {
                headers: {
                    //"Access-Control-Allow-Origin": "*",
                }
            }
        ).then((response) => {
            //console.log(response)
            let data = response.data
                
            //setRoleNew(data.role);
            localStorage.setItem('get-token-cube',data.cubeJWT);
            setTokenNew(data.cubeJWT)

        }).catch((error) => {
            
    
        })
    }*/
    
    function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    }

    useEffect(() => {
        const interval = setInterval(()=>{
            let token=""
            if(localStorage.getItem('token')){ 
                token = localStorage.getItem('token')
                let current = new Date();
                if(parseJwt(token).exp*1000 < current.getTime()){
                    logOut(imba_id);
                }
                else{
                    axios.post(
                        `https://api.imbachat.com/imbasupport/v2/${imba_id}/checktoken`,
                        {
                            token
                        },
                        {
                            headers: {
                                //"Access-Control-Allow-Origin": "*",
                            }
                        }
                    ).then((response) => {
                        let data = response.data
                        if(!data){
                            logOut(imba_id);
                        }
                    }).catch((error) => {
                    })
                }
                
            }
        },60000)
        return () => {
            clearInterval(interval)
          };
    }, [])
    useEffect(() =>{
        /*setCube(
            cubejs({
                transport: new WebSocketTransport({
                    authorization: localStorage.getItem('get-token-cube'),
                    apiUrl: API_URL.replace('https', 'wss'),
                }),
            })
        );*/
    }, [token_new])

    useEffect(() => {

    }, [sbKey])
    useEffect(() => {

    }, [role])
    useEffect(() => {
        if(localStorage.getItem('comet-token')){ 
            axios.post(
                `https://api.imbachat.com/imbachat/v1/widget/user_by_token/${imba_id}`,
                {
                    token: localStorage.getItem('comet-token')
                },
                {
                    headers: {
                        //"Access-Control-Allow-Origin": "*",
                    }
                }
            ).then((response) => {
               // console.log(response)
                let data = response.data
                    
                setRoleNew(data.role);
            }).catch((error) => {
                
        
            })
        }
        if(!localStorage.getItem('get-token-cube')){ 
            axios.post(
                `https://api.imbachat.com/imbachat/v1/${imba_id}/getTokenCube`,
                {
                    token: localStorage.getItem('comet-token')
                },
                {
                    headers: {
                        //"Access-Control-Allow-Origin": "*",
                    }
                }
            ).then((response) => {
                //console.log(response)
                let data = response.data
                    
                //setRoleNew(data.role);
                localStorage.setItem('get-token-cube',data.cubeJWT);
                setTokenNew(data.cubeJWT)
    
            }).catch((error) => {
                
        
            })
        }
    }, [token_new_init])
    useEffect(() => {
        const interval = setInterval(()=>{
            if(localStorage.getItem('comet-token')){ 
                setTokenNewInit(true)
                clearInterval(interval)
            }
        },1000)
        /*return () => {
            clearInterval(interval)
          };*/
    }, [])
    

    const getSideKey = () => {
        return sbKey
    }
    const setSideKey = (key) => {
        setSbKey(key)
    }
    const setCubeToken = (token) => {
        setToken(token);
    }
    const setRole = (role) => {
        setRoleNew(role);
    }
    const getRole = () => {
        if(role== undefined){
            CheckRole(imba_id).then((response) => {
                let data = response.data
                    setRole(data.role)
            }).catch((error) => {
        
            })
        }
        return role
    }
    const setLogin = (login) => {
        setLoginNew(login);
    }
    const getLogin = () => {
        return login
    }
    const setDelete = (deleted) => {
        setDeleteNew(deleted);
    }
    const getDelete = () => {
        return deleted
    }

    return (
        <DeleteContext.Provider value={{
            getDelete, setDelete
       }}>
        <LoginContext.Provider value={{
            getLogin, setLogin
       }}>
        <RoleContext.Provider value={{
             getRole, setRole
        }}>
        <CubeContext.Provider value={{
            setCubeToken
        }}>
            <CubeProvider cubejsApi={cube}>
                <SideContext.Provider value={{
                    getSideKey, setSideKey
                }}>
                    <AppLayout key="1">{children}</AppLayout>
                </SideContext.Provider>
            </CubeProvider>
        </CubeContext.Provider>
        </RoleContext.Provider>
        </LoginContext.Provider>
        </DeleteContext.Provider>
    )
};

export default App;